module.exports = __webpack_public_path__ + "img/gear-orange.baf5b6bf.png";